import React from 'react'
import classnames from 'classnames'
import { StyledWidget } from './styles'
import { DolaThemes } from '../../styles/types'
import { H2 } from '../../styles/Elements'

interface WidgetProps {
  className?: string
  clickable?: boolean
  header?: React.ReactChild
  onClick?: () => void
  theme?: DolaThemes
}

const Widget: React.FC<WidgetProps> = ({
  children,
  className = '',
  clickable,
  header,
  onClick,
  theme = 'light',
}) => {
  return (
    <StyledWidget
      className={classnames('widget', {
        [className]: !!className,
      })}
      clickable={clickable}
      dolaTheme={theme}
      onClick={() => clickable && onClick && onClick()}
    >
      {header && <H2>{header}</H2>}
      {children}
    </StyledWidget>
  )
}

export default Widget
